<div class="p-grid header-template">
  <div class="disp-icon">
    <fa-icon icon="home"></fa-icon>
  </div>
  <div class="p-col header-info">
    <div class="p-grid p-justify-between">
      <div class="p-col-9 property-search-address">
        <span class="property-search-address-main">
          {{property.Address.Address1}}
        </span>
        {{property.Address.City}}, {{property.Address.State}} {{property.Address.PostalCode}}
        <span class="fav-icon-left">
          <i #favIconEl
            [attr.data-fav-loan-icon-id]="'fav-loan-' + property.PropertyId" 
            [attr.data-fav-loan-flag]="property.IsFavorite"
            [ngClass]="getFavIconClass(property.IsFavorite)" 
            (click)="updateFavorite(favIconEl, property.PropertyId)">
          </i>
        </span>
      </div>
      <div class="p-col-3 strategy-corner strategy-corner-fcauc">{{property.DispositionStrategyGroup}}</div>     
    </div>
    <div class="p-grid">
      <div class="p-col-2"><span class="property-search-label">County</span> <br/><span class="property-search-values">{{property.County}}</span></div>
      <div class="p-col-2"><span class="property-search-label">FC Sale Date</span><br/><span class="property-search-values">{{property.FCSaleDate}}</span></div>
      <div class="p-col-2"><span class="property-search-label">FC Sale Time</span> <br/><span class="property-search-values">{{property.FCSaleTime}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Bid Amount</span><br/><span class="property-search-values">{{property.BidAmount}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Bid Type</span> <br/><span class="property-search-values">{{property.BidType}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Total Debt</span><br/><span class="property-search-values">{{property.TotalDebt}}</span></div>
    </div>
    <div class="p-grid">
      <div class="p-col-2">
        <span class="property-search-label">Loan Number</span><br/>
        <span *ngIf="!showPropertyIdLink; else propertyIdLink" class="property-search-values">
          {{property.LoanNumber}}
        </span>
        <ng-template #propertyIdLink>
          <span class="property-search-values">
            <a href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}">{{property.LoanNumber}}</a>
          </span>
        </ng-template>
        &nbsp;
        <a *ngIf="showOpenNewWindowIcon" href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}" target="_blank">
            <i class="pi pi-external-link"></i>
        </a>
      </div>
      <div class="p-col-2"><span class="property-search-label">Servicer Name</span><br/><span class="property-search-values">{{property.ServicerName}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Servicer Loan #</span><br/><span class="property-search-values">{{property.ServicerLoan}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Attorney Name</span><br/><span class="property-search-values">{{property.AttorneyName}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Attorney File #</span><br/><span class="property-search-values">{{property.AttorneyFileNumber}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Status</span><br/><span class="property-search-values">{{property.StatusLabel}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Workstation</span><br/><span class="property-search-values">{{property.Lender.PublicName}}</span></div>
    </div>
  </div>
</div>